import { LangValues } from '../type';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';

export type LangResources = Record<keyof typeof en, string>;

export const messages: Record<LangValues, LangResources> = {
  en: en,
  es: es,
  fr: fr,
};
